import React, { Component } from 'react';
import { createStackNavigator } from 'react-navigation-stack';
import {
  View, Text, StyleSheet, TouchableOpacity,
} from 'react-native';
import { version } from 'fitbeat-version';
import Theme from '../theme';
import { defaultScale } from '../utils/scaling';
import FaqScreen from './FaqScreen';
import QuestionScreen from './QuestionScreen';
import ContactScreen from './ContactScreen';
import LearnMoreAboutNutritionScreen from './LearnMoreAboutNutritionScreen';
import {
  BUILD_NUMBER, ENVIRONMENT, getConfig, getUrls,
} from '../config';
import { HelpListItem } from './components';
import { Icon } from '../components';
import { GoogleAnalytics } from '../services/google-analytics';
import { HeaderTitle, showMessage } from '../ui/components';
import { DeleteMyAccount } from './DeleteMyAccount';
import { openLink } from '../utils';

class HelpScreen extends Component {
  state = {
    helpItems: [
      {
        title: 'FAQ',
        toScreen: 'Faq',
      },
      {
        title: 'Legal',
        uri: getUrls().ALL_TERMS_AND_CONDITIONS,
      },
      {
        title: 'Contact Us',
        toScreen: 'Contact',
        isLast: false,
      },
      {
        title: 'Delete My Account',
        toScreen: 'DeleteMyAccount',
        isLast: true,
      },
    ],
  };

  googleAnalytics = new GoogleAnalytics();

  componentDidMount() {
    this.googleAnalytics.setCurrentScreen('HelpScreen');
  }

  render() {
    return (
      <View style={styles.container}>
        {this.state.helpItems.map((item) => this.buildButton(item))}

        <View style={styles.versionContainer}>
          {ENVIRONMENT.toggled
            ? (
              <Text style={styles.environmentText}>
                Environment:
                {getConfig().displayName}
              </Text>
            )
            : null}

          <TouchableOpacity
            onPress={() => showMessage(`Version ${version}, build # ${BUILD_NUMBER}`)}
          >
            <Text style={styles.versionText}>
              App Version:
              {version}
            </Text>
          </TouchableOpacity>
        </View>
      </View>
    );
  }

  buildButton = ({
    title,
    toScreen,
    uri,
    isLast = false,
  }) => {
    const { navigation } = this.props;
    const onPress = () => {
      if (uri) {
        openLink(uri);
      } else {
        navigation.navigate(toScreen);
      }
    };

    return (
      <HelpListItem
        key={title}
        title={title}
        isLast={isLast}
        onPress={onPress}
      />
    );
  };
}

const BuildHelpNavigator = (styles) => createStackNavigator({
  Help: {
    screen: HelpScreen,
    initialRouteName: 'Help',
  },
  Faq: {
    screen: FaqScreen,
  },
  LearnMoreAboutNutrition: {
    screen: LearnMoreAboutNutritionScreen,
    navigationOptions: () => ({
      headerTitle: () => <HeaderTitle title='FITILLION NUTRITION' />,
    }),
  },
  Contact: {
    screen: ContactScreen,
    navigationOptions: ({ navigation }) => ({
      headerTitle: () => <HeaderTitle title='CONTACT US' />,
    }),
  },
  DeleteMyAccount: {
    screen: DeleteMyAccount,
  },
  Question: {
    screen: QuestionScreen,
    navigationOptions: ({ navigation }) => ({
      headerTitle: () => <HeaderTitle title='FEEDBACK' />,
    }),
  },
}, {
  defaultNavigationOptions: ({ navigation }) => ({
    headerTitle: () => <HeaderTitle title='HELP' />,
    headerStyle: styles.headerWhite,
    headerRight: () => <View />,
    headerLeft: () => (
      <TouchableOpacity
        style={{ paddingLeft: defaultScale(15) }}
        onPress={() => {
          if (navigation.backReplacement) {
            if (navigation.backReplacement()) {
              return;
            }
          }

          navigation.goBack(null);
        }}
      >
        <Icon
          size={defaultScale(30)}
          color={Theme.GREY_DARK_MEDIUM}
          name='ios-arrow-back'
          style={styles.iconContainer}
        />
      </TouchableOpacity>
    ),
    cardStyle: {
      backgroundColor: Theme.CHARCOAL,
    },
  }),
});

const styles = StyleSheet.create({
  container: {
    flex: 1,
    paddingHorizontal: defaultScale(10),
    backgroundColor: Theme.WHITE,
    height: '100%',
  },
  versionContainer: {
    flex: 1,
    justifyContent: 'flex-end',
  },
  iconContainer: {
    paddingHorizontal: defaultScale(10),
  },
  versionText: {
    ...Theme.textStyle.bodyCopyReg,
    padding: defaultScale(10),
    textAlign: 'center',
    color: Theme.GREY,
  },
  environmentText: {
    ...Theme.textStyle.bodyCopyReg,
    padding: defaultScale(10),
    textAlign: 'center',
    color: Theme.RED,
  },
  formHeader: {
    paddingVertical: 5,
    borderTopWidth: 0.5,
    flexDirection: 'row',
    alignItems: 'center',
    backgroundColor: Theme.WHITE,
    justifyContent: 'space-between',
    borderTopColor: Theme.GREY_MEDIUM_LIGHT,
  },
  formHeaderBorderBottom: {
    borderBottomWidth: 0.5,
    borderBottomColor: Theme.GREY_MEDIUM_LIGHT,
  },
  formTitle: {
    fontSize: 16,

    fontFamily: Theme.Custom600,
    paddingVertical: 15,
    color: Theme.GREY_DARK_MEDIUM,
  },
});

export default BuildHelpNavigator;
